export default __webpack_public_path__ + "static/media/1928.9b3326b0.png";